"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDatasetProduct = void 0;
const routes_1 = require("../../routes");
const deleteDatasetProduct = (client) => async (productId) => {
    await client.delete(routes_1.ENDPOINTS.DELETE_DATASET_PRODUIT.applyParams(productId));
};
exports.deleteDatasetProduct = deleteDatasetProduct;
